export default __webpack_public_path__ + "static/media/ind7.d014315d.jpg";